import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-subtitle-1 font-weight-bold" }
const _hoisted_2 = { class: "text-subtitle-2 text-gray-600" }


import AccountsDialogViewModel from "@/viewmodels/dialogs/AccountsDialogViewModel";
import { Account } from "@/models/Account";


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountsDialog',
  setup(__props, { expose: __expose }) {

const viewModel = new AccountsDialogViewModel();

// Exponemos directamente los métodos sin usar `bind`
__expose({
  openDialog: (accountsData: Account[]) => viewModel.openDialog(accountsData),
  closeDialog: () => viewModel.closeDialog(),
});

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _unref(viewModel).dialog.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(viewModel).dialog.value) = $event)),
    persistent: "",
    "max-width": "600px"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "d-flex justify-between align-center" }, {
            default: _withCtx(() => [
              _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-subtitle-1 font-weight-bold" }, " Canales de Pago ", -1)),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                variant: "flat",
                icon: "",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(viewModel).closeDialog()))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                      _createTextVNode("mdi-close")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_container, {
                fluid: "",
                class: "pa-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { dense: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_text, { class: "px-0 pt-0" }, {
                            default: _withCtx(() => _cache[4] || (_cache[4] = [
                              _createTextVNode(" Estas son nuestras cuentas disponibles. ")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, { dense: "" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(viewModel).accounts.value, (account) => {
                        return (_openBlock(), _createBlock(_component_v_col, {
                          cols: "12",
                          key: account.id
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card, {
                              border: "",
                              flat: "",
                              class: "pa-4",
                              style: {"border-left":"7px solid rgb(var(--v-theme-primary), 0.4)"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "10" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_1, _toDisplayString(account.nom_banco), 1),
                                        _createElementVNode("div", _hoisted_2, [
                                          _cache[5] || (_cache[5] = _createElementVNode("strong", null, "CTA:", -1)),
                                          _createTextVNode(" " + _toDisplayString(account.numcuenta), 1)
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_col, {
                                      cols: "2",
                                      class: "d-flex align-center justify-end"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn, {
                                          variant: "flat",
                                          icon: "",
                                          onClick: ($event: any) => (_unref(viewModel).copyAccount(account)),
                                          "aria-label": 'Copiar cuenta de ' + account.nom_banco
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_icon, { color: "primary" }, {
                                              default: _withCtx(() => _cache[6] || (_cache[6] = [
                                                _createTextVNode("mdi-content-copy")
                                              ])),
                                              _: 1
                                            })
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick", "aria-label"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})